/**
 * Per-phase definitions and limitations for cycle time UI.
 * Keep wording aligned with backend `V2_CAVEATS` in `backend/src/services/repository/cycleTimeService.js`.
 */

/** @type {Record<string, string[]>} */
export const PHASE_HELP = {
  coding: [
    'Mean time from the first commit on the PR branch (sync enrichment) to PR opened.',
    'If first-commit enrichment is missing, we fall back to PR opened time—then coding length is zero.',
  ],
  pickup: [
    'Mean time from PR opened to the first non-author review or comment (sync enrichment).',
    'PRs merged with no recorded review activity have no pickup value.',
  ],
  review: [
    'Mean time from the first non-author review or comment through merge into your configured QA branch.',
    'When no review activity is recorded, review spans PR opened through merge (same as the previous combined metric).',
  ],
  qa: [
    'Mean gap between consecutive merge commits on your configured QA branch (merge commits captured during sync and push webhooks).',
    'Messages should start with "Merge " (GitHub default); squash merges or custom messages may be missed until the next sync.',
    'Run repository sync or use GitHub webhooks so merge data stays current.',
  ],
  uat: [
    'Mean gap between consecutive merge commits on your configured UAT branch, using the same merge-commit rules as QA.',
    'UAT→deploy matching uses merge messages that reference your configured UAT branch name (GitHub default merge text).',
    'Squash or non-standard merge messages may be missed; keep sync and webhooks active.',
  ],
  deploy: [
    'Mean gap between consecutive merge commits on your configured deployment branch.',
    'Cadence relies on stored merge commits (messages starting with "Merge "); non-standard merges may be missed until synced.',
    'Run repository sync or use GitHub webhooks so branch merge data stays current.',
  ],
};

/** @param {string} phaseKey */
export function getPhaseHelpLines(phaseKey) {
  const lines = PHASE_HELP[phaseKey];
  return Array.isArray(lines) ? lines : [];
}
